import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=5397f70c&scoped=true&"
import script from "./IconDelete.vue?vue&type=script&lang=js&"
export * from "./IconDelete.vue?vue&type=script&lang=js&"
import style0 from "./IconDelete.vue?vue&type=style&index=0&id=5397f70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397f70c",
  null
  
)

export default component.exports